import classNames from 'classnames';

interface Props {
  count?: number | string;
  title: string;
  icon?: string | null;
  iconAltText?: string;
  displayCount?: boolean;
}

const VenueContentBlockItem = ({
  count,
  title,
  icon,
  iconAltText,
  displayCount = true,
}: Props) => {
  const classes = classNames('venue-content-block__text', {
    'venue-content-block__text-no-icon': icon === null,
  });

  return (
    <li>
      {displayCount && (
        <span className="venue-content-block__quantity">{count || '0'}</span>
      )}
      {icon && (
        <img
          className="venue-content-block__icon"
          src={icon}
          alt={iconAltText}
        />
      )}
      <h4 className={classes}>{title}</h4>
    </li>
  );
};

export default VenueContentBlockItem;
